import React, { useState, useEffect } from "react";
import { Col, Container, Row, Alert, Modal } from "react-bootstrap";
import { TextInputForm, Calender } from "../../components/Forms";
import { ClickButton } from "../../components/ClickButton";
import PageNav from "../../components/PageNav";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import API_DOMAIN from "../../config/config";
import dayjs from "dayjs";
import debounce from "lodash.debounce";

const UserCreation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { type, rowData } = location.state || {};
  const [searchTexts, setSearchTexts] = useState({
    receipt_no: "",
    customer_details: "",
    mobile_number: "",
  });

  const [loading, setLoading] = useState(false);
  const [PawnData, setPawnUserData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [error, setError] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const redirectModal = () => {
    navigate("/console/master/jewelrecovery");
  };

  const initialState =
    type === "edit"
      ? {
        ...rowData,
        pawnjewelry_date: rowData.pawnjewelry_date,
        pawnjewelry_recovery_date: rowData.pawnjewelry_recovery_date,
      }
      : {
        receipt_no: "",
        pawnjewelry_date: "",
        customer_details: "",
        place: "",
        mobile_number: "",
        original_amount: "",
        interest_rate: "",
        pledged_items: "",
        item: "",
        total_weight: "",
        item_location: "",
        interest_income: 0,
        interest_payment_periods: "",
        refund_amount: "",
        pawnjewelry_recovery_date: new Date().toISOString().substr(0, 10),
      };

  const [formData, setFormData] = useState(initialState);

  const handleChange = (e, fieldName) => {
    const value = e.target ? e.target.value : e.value;
    // Update form data
    let updatedFormData = {
      ...formData,
      [fieldName]: value,
    };
    if (fieldName === "receipt_no" || fieldName === "mobile_number" || fieldName === "customer_details") {

      if (value.trim() === "") {
        // Clear all customer-related fields when input is empty
        updatedFormData = {
          ...updatedFormData,
          receipt_no: "",
          customer_details: "",
          place: "",
          mobile_number: "",
          original_amount: "",
          interest_rate: "",
          pledged_items: "",
          item: "",
          total_weight: "",
          item_location: "",
          pawnjewelry_date: "",
          interest_income: "",
          interest_payment_periods: "",
        };
        setSuggestions([]);

      } else {
        fetchJewelPawnData(value);
      }
    }
    setFormData(updatedFormData);
  };

  const setLabel = (date, label) => {
    const formattedDate = dayjs(date).format("YYYY-MM-DD");
    setFormData((prevData) => ({
      ...prevData,
      [label]: formattedDate,
    }));
  };

  // Function to parse interest_payment_periods (e.g., "1 month 23 days") to total days
  const parseInterestPaymentPeriods = (period) => {
    if (!period || period === "0 days") return 0;
    let totalDays = 0;
    const parts = period.split(" ");
    for (let i = 0; i < parts.length; i++) {
      if (parts[i].includes("month")) {
        totalDays += parseInt(parts[i - 1]) * 30; // 1 month = 30 days
      } else if (parts[i].includes("day")) {
        totalDays += parseInt(parts[i - 1]);
      }
    }
    return totalDays;
  };

  // Function to format total days to "months and days"
  const formatInterestPaymentPeriods = (totalDays) => {
    if (totalDays === 0) return "0 days";
    const months = Math.floor(totalDays / 30);
    const days = totalDays % 30;
    let periodString = "";
    if (months > 0) {
      periodString += `${months} month${months > 1 ? "s" : ""}`;
    }
    if (days > 0) {
      periodString += `${months > 0 ? " " : ""}${days} day${days > 1 ? "s" : ""
        }`;
    }
    return periodString || "0 days";
  };





  const handleSuggestionSelect = (item) => {
    const matchedInterestData = userData.filter(
      (data) =>
        data.receipt_no === item.receipt_no ||
        data.mobile_number === item.mobile_number
    );

    let totalInterestIncome = matchedInterestData.reduce(
      (total, data) => total + (parseFloat(data.interest_income) || 0),
      0
    );
    let totalDays = matchedInterestData.reduce(
      (total, data) => total + parseInterestPaymentPeriods(data.interest_payment_periods),
      0
    );

    const formattedPeriod = formatInterestPaymentPeriods(totalDays);

    // Set data to form
    setFormData((prevFormData) => ({
      ...prevFormData,
      receipt_no: item.receipt_no || "",
      customer_details: item.customer_details || "",
      place: item.place || "",
      mobile_number: item.mobile_number || "",
      original_amount: item.original_amount || "",
      interest_rate: item.interest_rate || "",
      pledged_items: item.pledged_items || "",
      item: item.item || "",
      total_weight: item.total_weight || "",
      item_location: item.item_location || "",
      pawnjewelry_date: item.pawnjewelry_date || "",
      interest_income: totalInterestIncome,
      interest_payment_periods: formattedPeriod,
    }));


    setSuggestions([]);
  };




  const fetchJewelPawnData = debounce(async (text) => {
    if (!text) {
      setSuggestions([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(`${API_DOMAIN}/pawnjewelry.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ search_text: text, limit: 5, offset: 0 }),
      });

      const responseData = await response.json();
      setLoading(false);
      if (responseData.head.code === 200) {
        setSuggestions(responseData.body.pawnjewelry || []);
      } else {
        setSuggestions([]);
        toast.error(responseData.head.msg);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error.message);
      toast.error("Failed to fetch suggestions.");
    }
  }, 400);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_DOMAIN}/interest.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ search_text: searchTexts }),
      });

      const responseData = await response.json();
      setLoading(false);
      if (responseData.head.code === 200) {
        setUserData(responseData.body.interest);
      } else {
        throw new Error(responseData.head.msg);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error.message);
    }
  };

  useEffect(() => {
    // if (searchText.length > 0) {
    fetchData();
    fetchJewelPawnData();
    // }
  }, [searchTexts]);

  const handleSubmit = async () => {
    try {
      const response = await fetch(`${API_DOMAIN}/pawnrecovery.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...formData, edit_pawnrecovery_id: "" }),
      });

      const responseData = await response.json();

      if (responseData.head.code === 200) {
        toast.success(responseData.head.msg);
        setTimeout(() => navigate("/console/master/jewelrecovery"), 1000);
      } else {
        toast.error(responseData.head.msg);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleUpdateSubmit = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_DOMAIN}/pawnrecovery.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...formData,
          edit_pawnrecovery_id: formData.pawnjewelry_recovery_id,
        }),
      });

      const responseData = await response.json();
      setLoading(false);

      if (responseData.head.code === 200) {
        toast.success(responseData.head.msg);
        setTimeout(() => navigate("/console/master/jewelrecovery"), 1000);
      } else {
        toast.error(responseData.head.msg);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error:", error);
    }
  };

  return (
    <div>
      <Container>
        <Row className="regular">
          <Col lg="12" md="12" xs="12" className="py-3">
            <PageNav
              pagetitle={`நகை மீட்பு${type === "view"
                  ? " வியூ "
                  : type === "edit"
                    ? " எடிட் "
                    : " உருவாக்கம்"
                }`}
            ></PageNav>
          </Col>
          <Col lg="3" md="6" xs="12" className="py-3">
            <TextInputForm
              placeholder={"அடகு எண்"}
              labelname={"அடகு எண்"}
              name="receipt_no"
              value={formData.receipt_no}
              onChange={(e) => handleChange(e, "receipt_no")}
            >
              {suggestions.length > 0 && (
                <ul className="suggestion-list">
                  {suggestions.map((item, idx) => (
                    <li key={idx} onClick={() => handleSuggestionSelect(item)}>
                      {item.receipt_no} - {item.customer_details} ({item.mobile_number})
                    </li>
                  ))}
                </ul>
              )}
            </TextInputForm>
          </Col>
          <Col lg="3" md="6" xs="12" className="py-3">
            <Calender
              setLabel={(date) => setLabel(date, "pawnjewelry_date")}
              calenderlabel="நகை அடகு வைத்த தேதி"
              disabled={type === "view" || type === "edit"}
              initialDate={formData.pawnjewelry_date}
            />
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"பெயர்"}
              labelname={"பெயர்"}
              name="customer_details"
              value={formData.customer_details}
              onChange={(e) => handleChange(e, "customer_details")}
            >
              {suggestions.length > 0 && (
                <ul className="suggestion-list">
                  {suggestions.map((item, idx) => (
                    <li key={idx} onClick={() => handleSuggestionSelect(item)}>
                      {item.customer_details} - {item.receipt_no} ({item.mobile_number})
                    </li>
                  ))}
                </ul>
              )}
            </TextInputForm>
          </Col>

          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"இடம்"}
              labelname={"இடம்"}
              name="place"
              value={formData.place}
              onChange={(e) => handleChange(e, "place")}
            />
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"மொபைல் எண்"}
              labelname={"மொபைல் எண்"}
              name="mobile_number"
              value={formData.mobile_number}
              onChange={(e) => handleChange(e, "mobile_number")}
            >
              {suggestions.length > 0 && (
                <ul className="suggestion-list">
                  {suggestions.map((item, idx) => (
                    <li key={idx} onClick={() => handleSuggestionSelect(item)}>
                      {item.mobile_number} - {item.receipt_no} ({item.customer_details})
                    </li>
                  ))}
                </ul>
              )}
            </TextInputForm>

          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"அசல் தொகை"}
              labelname={"அசல் தொகை"}
              name="original_amount"
              value={formData.original_amount}
              onChange={(e) => handleChange(e, "original_amount")}
            />
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"வட்டி விகிதம்"}
              labelname={"வட்டி விகிதம்"}
              name="interest_rate"
              value={formData.interest_rate}
              onChange={(e) => handleChange(e, "interest_rate")}
            />
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"அடகு பொருட்கள்"}
              labelname={"அடகு பொருட்கள்"}
              name="pledged_items"
              value={formData.pledged_items}
              onChange={(e) => handleChange(e, "pledged_items")}
            />
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"உருப்படி"}
              labelname={"உருப்படி"}
              name="item"
              value={formData.item}
              onChange={(e) => handleChange(e, "item")}
            />
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"மொத்த எடை"}
              labelname={"மொத்த எடை"}
              name="total_weight"
              value={formData.total_weight}
              onChange={(e) => handleChange(e, "total_weight")}
            />
          </Col>

          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"வட்டி வரவு ரூபாய்"}
              labelname={"வட்டி வரவு ரூபாய்"}
              name="interest_income"
              value={formData.interest_income}
              onChange={(e) => handleChange(e, "interest_income")}
            />
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"வட்டி வரவு காலம்"}
              labelname={"வட்டி வரவு காலம்"}
              name="interest_payment_periods"
              value={formData.interest_payment_periods}
              onChange={(e) => handleChange(e, "interest_payment_periods")}
            />
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"வாபஸ் தொகை"}
              labelname={"வாபஸ் தொகை"}
              name="refund_amount"
              value={formData.refund_amount}
              onChange={(e) => handleChange(e, "refund_amount")}
            />
          </Col>
          <Col lg="3" md="6" xs="12" className="py-3">
            <Calender
              setLabel={(date) => setLabel(date, "pawnjewelry_recovery_date")}
              initialDate={
                type === "edit" ? formData.pawnjewelry_recovery_date : undefined
              }
              calenderlabel="நகை அடகு மீட்பு தேதி"
              disabled={type === "view" || type === "edit"}
            />
          </Col>

          <Col lg="12">
            <div className="text-center">
              {type === "view" ? (
                <span className="mx-2">
                  <ClickButton
                    label={<>back</>}
                    onClick={() => navigate("/console/master/JewelRecovery")}
                  />
                </span>
              ) : (
                <>
                  {type === "edit" ? (
                    <>
                      <ToastContainer
                        position="top-center"
                        autoClose={2000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="colored"
                      />
                      <span className="mx-2">
                        <ClickButton
                          label={<>Update</>}
                          onClick={handleUpdateSubmit}
                        />
                      </span>
                      <span className="mx-2">
                        <ClickButton
                          label={<>cancle</>}
                          onClick={() =>
                            navigate("/console/master/JewelRecovery")
                          }
                        />
                      </span>
                    </>
                  ) : (
                    <>
                      <ToastContainer
                        position="top-center"
                        autoClose={2000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="colored"
                      />
                      <span className="px-2">
                        <ClickButton
                          label={<> Submit</>}
                          onClick={handleSubmit}
                          disabled={loading}
                        />
                      </span>
                      <span className="px-2">
                        <ClickButton
                          label={<> Cancle</>}
                          onClick={() =>
                            navigate("/console/master/JewelRecovery")
                          }
                          disabled={loading}
                        />
                      </span>
                    </>
                  )}
                </>
              )}
            </div>
          </Col>
        </Row>

        {error && (
          <Alert variant="danger" className="error-alert">
            {error}
          </Alert>
        )}
      </Container>
      <Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        centered
      >
        <Modal.Body className="text-center">
          <img
            src={require("../../components/sidebar/images/output-onlinegiftools.gif")}
            alt="Success GIF"
          />
          <p>User saved successfully!</p>
        </Modal.Body>
        <Modal.Footer>
          <ClickButton
            variant="secondary"
            label={<> Close</>}
            onClick={() => redirectModal()}
          />
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default UserCreation;
